var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.icons),function(item){return _c('span',{key:item.name,staticClass:"mr-2"},[_c('v-icon',{attrs:{"medium":"","color":item.active === _vm.active ? 'primary' : ''},domProps:{"textContent":_vm._s(item.name)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }